export class EditedFilter {
    canBeAdded() {
        return false;
    }

    toConcreteFilter() {
        throw new Error('Unknown concrete filter');
        return {};
    }
}